import api from '../../../api/client';
import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Button, Space, message, Spin } from "antd";
import axios from "axios"

const RoleForm = ({ visible, onCancel, onSuccess, initialData, apiUrl }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (initialData) {
      form.setFieldsValue({ name: initialData.name });
    } else {
      form.resetFields();
    }
  }, [initialData, form]);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      if (initialData) {
        await api.put(`/roles/${initialData.id}`, values);
        message.success("Role updated");
      } else {
        await api.post(`/roles`, values);
        message.success("Role created");
      }
      onSuccess();
      onCancel();
    } catch (err) {
      message.error(err.response?.data?.message || "Operation failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal title={initialData ? "Edit Role" : "Add Role"} open={visible} onCancel={onCancel} footer={null} width={500}>
      <Spin spinning={loading}>
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Form.Item name="name" label="Role Name" rules={[{ required: true, message: "Please enter role name" }]}>
            <Input placeholder="e.g., Administrator, Farm Manager, Veterinarian" />
          </Form.Item>
          <Form.Item><Space><Button type="primary" htmlType="submit">Save</Button><Button onClick={onCancel}>Cancel</Button></Space></Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
};

export default RoleForm;